<template>
  <div class="map-root select-none">
    <div ref="map-mapview" class="map"></div>
    <div class="global-loading">
      <table>
        <tr>
          <td>
            <span class="global-loading-text" v-html="loadingText"></span>
          </td>
        </tr>
      </table>
    </div>
    <div class="cocketmap-control">
      <div class="cocketmap-control-box">
        <div class="map-box-left map-box-display">
          <div class="imgbox tucengimg_off"></div>
          <div class="list_box tuceng_list_box">
            <DrawerPop
              :list="layerList"
              @select="layerSelect"
              ref="layerPop"
            ></DrawerPop>
          </div>
          <div @click="showLayerPop" class="lalyer_item">
            <div class="text">
              {{ layerTypeSelect.name }}
            </div>
            <div class="iconfont iconarrow-down-bold"></div>
          </div>
        </div>
        <div class="map-box-right map-box-display" @click="handleSwitch2D3D">
          <div class="imgbox pingmianimg_off"></div>
          <div>{{ threeDChecked ? "2D" : "3D" }}</div>
        </div>
      </div>
      <div class="cocketmap-control-box">
        <div class="map-box-left map-box-display" @click="goCenter">
          <div class="imgbox centerimg_off"></div>
          <div class="tuceng">中心点</div>
        </div>
        <div class="map-box-right map-box-display" @click="setHead">
          <div class="imgbox zhinanimg_off"></div>
          <div>方向</div>
        </div>
      </div>
    </div>

    <el-dialog
      class="map_popup_dialog2"
      v-if="isVideoMonitorDialogVisible"
      top="30vh"
      :visible.sync="isVideoMonitorDialogVisible"
      :modal-append-to-body="false"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="实时监控"
    >
      <div class="w100_h100">
        <div class="map_popupbox w100_h15 p10_20_0_0">
          <div class="column">
            <span class="item font1">{{ cameraName }}</span>
            <span class="item">{{
              cameraIsOnline == "1" ? "在线" : "离线"
            }}</span>
          </div>
        </div>
        <div class="videoBig-item w100_h85">
          <flv-player-real-time
            class="videoBig-item"
            :cameraId="cameraId"
            :cameraName="cameraName"
            :cameraIsOnline="cameraIsOnline"
            :autoplay="autoplay"
            :streamType="streamType"
            viewMode="noclose"
          />
        </div>
      </div>
    </el-dialog>
    <el-dialog
      class="map_popup_dialog2"
      v-if="isSoSMonitorDialogVisible"
      top="30vh"
      :visible.sync="isSoSMonitorDialogVisible"
      :modal-append-to-body="false"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="实时监控"
    >
      <div class="w100_h100">
        <div class="map_popupbox w100_h15 p10_20_0_0">
          <div class="column">
            <span class="item font1">{{ cameraName }}</span>
            <span class="item">{{
              cameraIsOnline == "1" ? "在线" : "离线"
            }}</span>
          </div>
        </div>
        <div class="videoBig-item w100_h85">
          <flv-player-real-time
            class="videoBig-item"
            :cameraId="cameraId"
            :cameraName="cameraName"
            :cameraIsOnline="cameraIsOnline"
            :autoplay="autoplay"
            :streamType="streamType"
            viewMode="noclose"
          />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import DrawerPop from "./DrawerPop";
import MapDevicePop from "./MapDevicePop";
// import MapWifiPop from "./MapWifiPop";
// import MapCarparkPop from "./MapCarparkPop";
import Vue from "vue";
var areaPopup; //全局定义弹窗（在data中定义弹窗，会出现黑色区域）
export default {
  components: {
    DrawerPop,
    MapDevicePop,
    // MapWifiPop,
    // MapCarparkPop,
  },
  // 可接收 URL 参数。
  // 仅当通过 url 跳转的时候可接收这些参数。
  // 也可通过 this.$route.query 来查询 url 参数。
  props: {
    MapKey: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      loadingText: "加载中...",
      dSelected: false,

      layerList: [
        { name: "图层", type: "off" },
        { name: "暂无可加载的图层", type: "none" },
      ],
      threeDChecked: true,
      layerIndex: 0,
      popupTemp: null,
      isBroadcastDialogVisible: false,
      isWifiPopVisible: false,
      isCarparkPopVisible: false,
      isLEDPopVisible: false,
      isVideoMonitorDialogVisible: false,
      isSoSMonitorDialogVisible: false,
      deviceDetail: {
        deviceName: "",
        deviceIsOnline: "",
        deviceIP: "",
        deviceRegionName: "",
      },
      ledDetail: {
        deviceName: "",
        deviceIsOnline: "",
        deviceIP: "",
        deviceRegionName: "",
      },
      wifiDetail: {
        deviceName: "",
        deviceIsOnline: "",
        deviceIP: "",
        deviceRegionName: "",
        count: null,
      },
      carparkDetail: {
        name: "",
        totalPlace: 0,
        usedSpace: 0,
        percent: 0,
      },
      cameraId: "",
      cameraName: "",
      cameraIsOnline: true,
    };
  },
  computed: {
    layerTypeSelect({ layerList, layerIndex }) {
      return layerList ? layerList[layerIndex] : { name: "图层" };
    },
  },
  methods: {
    //2d3d切换
    handleSwitch2D3D() {
      const that = this;
      const map = that.mapInstance.map;

      if (map.getPitch() == 0) {
        this.threeDChecked = true;
        map.setPitch(60);
      } else {
        this.threeDChecked = false;
        map.setPitch(0);
      }
    },
    setHead() {
      const map = this.mapInstance.map;
      map.setBearing(0);
    },
    goCenter: function () {
      const that = this;
      const map = that.mapInstance.map;

      map.flyTo({
        center: that.mapInstance.coordEncoder.to(
          that.mapInstance.config.center
        ),
        zoom: that.mapInstance.config.zoom,
      });
    },
    showLayerPop() {
      !this.$refs.layerPop.isShow
        ? this.$refs.layerPop.show()
        : this.$refs.layerPop.hide();
    },
    layerSelect({ index }) {
      this.layerIndex = index;
    },
    addDom: function () {
      if (!this.mapInstance) return;

      // eslint-disable-next-line no-undef
      var $div = $("<div></div>");
      $div.append(this.getSvgContent());
      $div.css({
        width: "30rem",
        height: "30rem",
        "margin-left": "-15rem",
        "margin-top": "-15rem",
        position: "absolute",
      });

      var interval = setInterval(() => {
        let layer = this.mapInstance.getLayerByName("DOM");
        if (layer && layer.addDom) {
          clearInterval(interval);
          layer.addDom(this.center[0], this.center[1], $div[0]);
        }
      }, 1000);
    },
    addBlinkPoi: function () {
      if (this.mapInstance) {
        // eslint-disable-next-line no-undef
        var target = new BMap.Point(this.center[0], this.center[1]);
        //this.mapInstance.panTo(center);
        //this.mapInstance.panTo(target);
        var pictureUrl = this.BASE_URL + "theme/default/img/animation10.gif";
        // eslint-disable-next-line no-undef
        var myIcon = new BMap.Icon(pictureUrl, new BMap.Size(1000, 1000));
        // eslint-disable-next-line no-undef
        var marker = new BMap.Marker(target, { icon: myIcon }); // 创建标注
        this.mapInstance.addOverlay(marker);
      }
    },
    getSvgContent: function () {
      var html =
        "" +
        '<div class="svg_container">' +
        '  <div class="svg-box">' +
        '     <svg version="1.1"  x="0px" y="0px" viewBox="0 0 100 100"' +
        '         enable-background="new 0 0 100 100" xml:space="preserve">' +
        '       <circle fill="rgba(244,16,11,5)" cx="50" cy="50" r="5" />' +
        '       <circle fill="rgba(244,16,11,0.2)" cx="50" cy="50" r="20" />' +
        '       <circle fill="rgba(244,16,11,0.1)" cx="50" cy="50" r="35" />' +
        "     </svg>" +
        "  </div>" +
        '  <div class="circle delay1"></div>' +
        '  <div class="circle delay2"></div>' +
        '  <div class="circle delay3"></div>' +
        "</div>";
      return html;
    },
    //资源点查询方法，过滤地图点位
    search: function (text) {
      var map = this.mapInstance;
      var layers = map.getLayers();

      if (text) {
        // eslint-disable-next-line no-undef
        $(layers).each(function () {
          if (this.$className === "OverlayLayer") {
            this.filter(function (d) {
              var label = this.getLabel(d) || "";
              return label.indexOf(text) >= 0;
            });
          }
        });
      } else {
        // eslint-disable-next-line no-undef
        $(layers).each(function () {
          if (this.$className === "OverlayLayer") {
            this.clearFilter();
          }
        });
      }
    },
    // eslint-disable-next-line no-unused-vars
    onSearchResultPoiSelected: function (id) {
      var overlay,
        layers = this.mapInstance.getLayers();

      for (let index = 0; index < layers.length; index++) {
        var ly = layers[index];
        if (ly.findOverlayById) {
          overlay = ly.findOverlayById(id);
          if (overlay && overlay.length > 0) {
            ly.onClick.apply(overlay[0], [{}]);
            break;
          }
        }
      }
    },
    layerButtonClick: function (data) {
       this.$emit("layerButtonClick", data);
      // let e = data.e;
      // switch (data.action) {
      //   case "videomonitor":
      //     this.cameraId = e.data.equipmentCode;
      //     this.cameraName = e.data.equipmentName;
      //     this.cameraIsOnline = e.data.onlineStatus;
      //     this.isVideoMonitorDialogVisible = true;
      //     //移除地图弹窗
      //     if (areaPopup) {
      //       areaPopup.remove();
      //     }
      //     break;
      //   case "SOSPop":
      //     this.cameraId = e.data.DeviceId;
      //     this.cameraName = e.data.DeviceName;
      //     this.cameraIsOnline = e.data.IsOnline;
      //     //  this.isVideoMonitorDialogVisible = true;
      //     this.isSoSMonitorDialogVisible = true;
      //     //移除地图弹窗
      //     if (areaPopup) {
      //       areaPopup.remove();
      //     }
      //     break;

      //   case "broadcastPop":
      //     this.deviceDetail.deviceName = e.data.DeviceName;
      //     this.deviceDetail.deviceIsOnline = e.data.IsOnline ? "在线" : "离线";
      //     this.deviceDetail.deviceIP = JSON.parse(e.data.JsonExtend).IP;
      //     this.deviceDetail.deviceRegionName = e.data.RegionName;
      //     let position = this.mapInstance.coordEncoder.to([
      //       e.data.Longitude,
      //       e.data.Latitude,
      //     ]);
      //     //移除地图弹窗
      //     if (areaPopup) {
      //       areaPopup.remove();
      //     }
      //     // 添加弹窗
      //     let popDetail = Vue.extend(MapDevicePop);
      //     let vm = new popDetail({
      //       propsData: {
      //         detail: this.deviceDetail,
      //         type: "broadcast",
      //       },
      //     });
      //     vm.$mount(); //挂载
      //     this.popupTemp = vm.$el;

      //     areaPopup = new mapboxgl.Popup({
      //       closeOnClick: false,
      //       offset: 25,
      //     })
      //       .setLngLat([position.lng, position.lat])
      //       .setDOMContent(this.popupTemp)
      //       .addTo(this.mapInstance.map);

      //     break;
      //   case "WiFiPop":
      //     this.wifiDetail.deviceName = e.data.Name;
      //     this.wifiDetail.deviceIsOnline =
      //       e.data.Status === 1 ? "在线" : "离线";
      //     this.wifiDetail.deviceIP = e.data.IP;
      //     this.wifiDetail.deviceRegionName = e.data.Extend1;
      //     this.wifiDetail.count = e.data.VisitorCount;
      //     position = this.mapInstance.coordEncoder.to([
      //       e.data.Longitude,
      //       e.data.Latitude,
      //     ]);
      //     //移除地图弹窗
      //     if (areaPopup) {
      //       areaPopup.remove();
      //     }
      //     // 添加弹窗
      //     popDetail = Vue.extend(MapWifiPop);
      //     vm = new popDetail({
      //       propsData: {
      //         detail: this.wifiDetail,
      //       },
      //     });
      //     vm.$mount(); //挂载
      //     this.popupTemp = vm.$el;

      //     areaPopup = new mapboxgl.Popup({
      //       closeOnClick: false,
      //       offset: 25,
      //     })
      //       .setLngLat([position.lng, position.lat])
      //       .setDOMContent(this.popupTemp)
      //       .addTo(this.mapInstance.map);
      //     break;
      //   case "CarparkPop":
      //     this.carparkDetail.name = e.data.Name;
      //     this.carparkDetail.totalPlace = e.data.TotalPlace;
      //     this.carparkDetail.usedSpace = e.data.UsedSpace;

      //     this.carparkDetail.percent =
      //       (e.data.UsedSpace / e.data.TotalPlace).toFixed(2) * 100 || 0;
      //     position = this.mapInstance.coordEncoder.to([
      //       e.data.Longitude,
      //       e.data.Latitude,
      //     ]);
      //     //移除地图弹窗
      //     if (areaPopup) {
      //       areaPopup.remove();
      //     }
      //     // 添加弹窗
      //     popDetail = Vue.extend(MapCarparkPop);
      //     vm = new popDetail({
      //       propsData: {
      //         detail: this.carparkDetail,
      //       },
      //     });
      //     vm.$mount(); //挂载
      //     this.popupTemp = vm.$el;

      //     areaPopup = new mapboxgl.Popup({
      //       closeOnClick: false,
      //       offset: 25,
      //     })
      //       .setLngLat([position.lng, position.lat])
      //       .setDOMContent(this.popupTemp)
      //       .addTo(this.mapInstance.map);
      //     break;
      //   case "LEDPop":
      //     this.ledDetail.deviceName = e.data.NAME_EQT;
      //     this.ledDetail.deviceIsOnline =
      //       e.data.STATE_EQT === 1 ? "在线" : "离线";
      //     this.ledDetail.deviceIP = e.data.IPAdd_EQT;
      //     this.ledDetail.deviceRegionName = e.data.ARENUM_EQT;
      //     position = this.mapInstance.coordEncoder.to([
      //       e.data.Longitude,
      //       e.data.Latitude,
      //     ]);
      //     //移除地图弹窗
      //     if (areaPopup) {
      //       areaPopup.remove();
      //     }
      //     // 添加弹窗
      //     popDetail = Vue.extend(MapDevicePop);
      //     vm = new popDetail({
      //       propsData: {
      //         detail: this.ledDetail,
      //         type: "LED",
      //       },
      //     });
      //     vm.$mount(); //挂载
      //     this.popupTemp = vm.$el;

      //     areaPopup = new mapboxgl.Popup({
      //       closeOnClick: false,
      //       offset: 25,
      //     })
      //       .setLngLat([position.lng, position.lat])
      //       .setDOMContent(this.popupTemp)
      //       .addTo(this.mapInstance.map);
      //     break;
      //   default:
      //     this.$message({ type: "warning", message: data.action + "未实现" });
      //     break;
      // }
    },
    togleSwitchClick(e) {
      this.$emit("togleSwitchClick", e);
    },
    onGotLayerData(e) {
      this.$emit("gotLayerData", e);
    },
  },
  created() {
    console.debug("mapview created");
    // 组件创建时，设置本页样式
    // eslint-disable-next-line no-undef
    // $(".zj-app").addClass("zj-fullscreen-mapview");
    this.$on("poiselected", this.onSearchResultPoiSelected);
  },
  mounted() {
    $(".zj-app").addClass("zj-fullscreen-mapview");
    // 创建地图，并通过样式让地图填满窗口
    let that = this;
    let mapkey = this.MapKey;
    this.$nextTick(function () {
      // 不传入 syscode 和 key ，或者值为空时，
      // zjumap 插件自动从 URL 地址
      // http://HOST:PORT/Areas/Map/Content/UMap.html?syscode=xxx&key=yyy
      // 中读取 syscode 和 key 的值。
      // eslint-disable-next-line no-undef
      $(that.$refs["map-mapview"]).zjumap({
        syscode: "ZJMap",
        key: mapkey,
        loading: ".global-loading",
        loadingText: ".global-loading-text",
        //地图配置
        mapConfigs: {
          // mapStyle: "styles/darknight.json",
          // toggleTool: "tool/TreeToggleIndex",
          //toggleTool: "tool/TreeToggleX",
          tilesPath: that.CNF('api.base_url') + global.$config.api.shMapUrl, 
          // tilesPath: that.CNF('api.base_url') + "/hmap3",
          // zoom: 14,
          // layerDefineFile: "js/layers-tree.js", //图层定义文件
          //mapVender: that.MapVender,

          onMapCreated: function (e) {
            that.mapInstance = e.map;
            that.center = e.map.config.center;

            //that.addDom();
          },
          onGettingLayerData: function (e) {
            // eslint-disable-next-line no-undef
            e.opts.ServiceData = $.extend({}, e.opts.ServiceData, {
              // Longitude: that.center[0],
              // Latitude: that.center[1],
            });
            //that.onGettingLayerData(e);
          },
          onGotLayerData: function (e) {
            that.onGotLayerData(e);
          },
          onLayerButtonClick: function (e) {
            var item = e.originEvent.currentTarget;
            // eslint-disable-next-line no-undef
            var action = $(item).data("action") || e.action;
            var data = {
              e: e,
              action: action,
            };
            that.layerButtonClick(data);
          },
          //地图开关面板切换事件，切换右侧列表框的tab项
          onToogleSwitchClick: function (e) {
            that.togleSwitchClick(e);
            // that.broadcast(
            //   "HomeViewPassengerFlowCockpit",
            //   "onMapToogleGroupSwitchClick",
            //   e.type
            // );
          },
          // onLayerDetaiButtonClick: function (e) {
          //   console.log(e);
          //   var item = e.originEvent.currentTarget;
          //   // eslint-disable-next-line no-undef
          //   var id = $(item).data("id");
          //   // eslint-disable-next-line no-undef
          //   var category = $(item).data("category");
          //   var result = {
          //     obj: id,
          //     type: "search",
          //     category: category,
          //   };
          //   that.showRecordDetail(result);
          // },
        },
        //,gotMapConfigs: function (conf, opts) { } //当从统一配置中获取到地图配置，并合并完 mapConfigs 后，触发此事件。
      });
    });
  },
  beforeDestroy() {
    if (this.mapInstance) {
      this.mapInstance.destroy();
      this.mapInstance = null;
      console.debug("mapview beforeDestroy");
    }
  },
  destroyed() {
    console.debug("mapview destroyed");
    // 销毁组件时，还原样式
    // eslint-disable-next-line no-undef
    $(".zj-app").removeClass("zj-fullscreen-mapview");
  },
};
</script>
<style lang="scss" scoped>
@import url("../../../../font/iconfont.css");
.lalyer_item {
  display: flex;
  align-items: center;
  width: 100%;
  .text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: -webkit-box;
    margin: 0 0.25rem;
  }
}
.list_box {
  position: absolute;
  z-index: 10001;
}

.tuceng_list_box {
  left: 4px;
  top: 0;
  width: 145px;
}
/deep/ .mapboxgl-popup-content {
  background-color: transparent;
  border-radius: 0px 0px;
  overflow: hidden;
  padding: 0;
  width: 42.5rem;
  height: 18.125rem;
  color: #d6f0ff;
  // background-image: url("../../../theme-default/src/images/bg_broadcast.png");
  // background-repeat: no-repeat;
  // background-size: 100% 100%;
}
/deep/ .mapboxgl-popup-close-button {
  top: 3.5rem;
  right: 4px;
  color: #fff;
}
/deep/ .mapboxgl-popup-tip {
  display: none;
}
.iconfont{
  font-size: 0.5rem;
}
</style>